import Nullstack from 'nullstack';
export default function IconDeviceCctv({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-device-cctv",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "14",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M19 7v7a7 7 0 0 1 -14 0v-7"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "14",
    x2: "12.01",
    y2: "14"
  }), " ");
}